import { advanceTrains } from '@tol/core/live-motion';
import type { TrackedTrain, TrackedTrains, TrainId } from '@tol/core/types';
import type { Network } from '@tol/core/gps-types';

export function advanceGpsTrains(
  net: Network,
  trains: TrackedTrains,
  now: number,
  dt: number,
  reset = false,
  near?: Parameters<typeof advanceTrains>[5],
): TrainId[] {
  const held: (readonly [TrainId, TrackedTrain])[] = [];
  const removed: TrainId[] = [];
  for (const [id, train] of trains) {
    const point = train.pred.gpsPoint;
    if (!point || train.pred.motionTracker === true) continue;
    trains.delete(id);
    if (now - point.at >= 180_000 || point.at > now + 30_000) {
      removed.push(id);
      continue;
    }
    train.motion.pos = { ...point, P: null, N: train.pred.N, f: 1, ang: null, segment: `gps|${id}`, snapped: false };
    train.motion.moving = false;
    train.alpha += ((train.dead ? 0 : 1) - train.alpha) * Math.min(1, dt / 500);
    if (train.dead && train.alpha < 0.02) removed.push(id);
    else held.push([id, train]);
  }
  removed.push(...advanceTrains(net, trains, now, dt, reset, near));
  for (const [id, train] of held) trains.set(id, train);
  return removed;
}
